import React, { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'


const ShortLink = () => {
    const params = useParams()
    const location = useLocation();
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/ProductPermanentLink/GetPermanentLinkDetails?shortLink=${params.shortLinkParam}`)
            .then((response) => response.json()).then((response) => {
                console.log(response)
                if (response.IsProduct) {
                    window.location.href = `/#/landingPurchase/step-1/${response.ProductType}/${response.ProductId}/${response.ContractTypeId}${location.search}`
                } else {
                    if (response.FullUrl.includes("call-activity")) {
                        window.location.href = "/#/callReport"

                    }else
                    if (response.FullUrl.includes("customer-member")) {
                        window.location.href = "/#/customerMember/members"

                    }else
                    if (response.FullUrl.includes("purchase-line")) {
                        window.location.href = "/#/purchaseLine/selectionNumber/false/false"

                    }else
                    if (response.FullUrl.includes("signup")) {
                        window.location.href = "/#/register"

                    }else{
                        window.location.href = response.FullUrl

                    }
                }

            }).catch(function (error) {
                console.log(error)
                window.location.href = "/#/dashboard"
            });

    }, [])
    return (
        <div></div>
    )
}

export default ShortLink